import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './LoadingPrompt.module.scss';

import {
  agodaLogo,
  bookingLogo,
  expediaLogo,
  hotelsLogo,
  tripLogo,
} from '@shared/ui/components/logos/images';
import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

const LoadingPrompt = ({ i18n }: { i18n: I18nService }) => (
  <div className={cls('LoadingPrompt')} data-testid="offers-loading-prompt">
    <div className={cls('LoadingPrompt__container')}>
      <img className={cls('LoadingPrompt__logo')} src={agodaLogo} alt="Agoda" />
      <img
        className={cls('LoadingPrompt__logo')}
        src={bookingLogo}
        alt="Booking.com"
      />
      <img
        className={cls('LoadingPrompt__logo')}
        src={hotelsLogo}
        alt="Hotels.com"
      />
      <img
        className={cls('LoadingPrompt__logo')}
        src={tripLogo}
        alt="Trip.com"
      />
      <img
        className={cls('LoadingPrompt__logo')}
        src={expediaLogo}
        alt="Expedia"
      />
    </div>
    <BpkText
      textStyle={TEXT_STYLES.label1}
      className={cls('LoadingPrompt__content')}
    >
      {i18n.translate('ktxt_Compare_RoomAndPrice_desc_Label')}
    </BpkText>
  </div>
);

export default withI18n(LoadingPrompt);
